
    var riot = require('riot')
    //src: starling/src/tags/menu/items/menu-item-card-style.html
riot.tag2('menu-item-card-style',
  '<span class="styled-card-icon styled-card-icon--small styled-card-icon--{getSelectedStyle()}" riot-style="{cardColorStyle()}"> <svg class="floating-menu_icon"> <use xlink:href="#styled-card-icon"></use> </svg> </span> <span class="floating-menu_label">Card Style</span> <svg class="floating-menu_caret"> <use xlink:href="#caret-right-icon"></use> </svg> <div class="colorPicker"> <color-picker if="{isOpen}" positioning="{colorPickerPosition()}" colors="{cardColors}" setcolor="{setCardColor}" selectedcolor="{getSelectedColor()}" selectedstyle="{getSelectedStyle()}" type="card"></color-picker> </div>',
  '',
  'class="{opts.classes} floating-menu_item color-picker-row" onmouseenter="{openCardStylePicker}"', function(opts) {
'use strict';

var _this = this;

var _util = require('lib/util');

var _constants = require('lib/constants');

var _nodesUi = require('lib/nodes-ui');

var _menuUi = require('lib/menu-ui');

var _delayHandler = require('lib/delay-handler');

this.cardColors = _constants.CARD_COLORS;
this.isOpen = false;

_menuUi.mui.registerMenuItem(this, 'cardStyle');

this.getSelectedColor = _menuUi.mui.getCardSelectedColor.bind(this);
this.getSelectedStyle = _menuUi.mui.getCardSelectedStyle.bind(this);
this.setCardColor = _menuUi.mui.setCardColor.bind(this);
this.setDisplayStyle = _menuUi.mui.setDisplayStyle.bind(this);

this.openCardStylePicker = function () {
  _delayHandler.delayHandler.initializeDelay({
    action: 'submenus',
    id: 'cardcolor',
    delay: _constants.MENU_OPEN_DELAY,
    callback: function callback() {
      _this.noHide = true; // don't trigger hideSubMenu in this component when parent.hideSubmenus is called
      _this.parent.hideSubMenus();
      _this.isOpen = true;
      _this.update();
    }
  });
};

this.hideSubMenu = function () {
  if (_this.isOpen && !_this.noHide) {
    _this.isOpen = false;
    _this.update();
  }
  delete _this.noHide;
};

this.colorPickerPosition = function () {
  if (_this.parent.positionSubToLeft) {
    return 'top: 0px; left: -233px;';
  }
  return 'top: 0px; left: 100%';
};

this.cardColorStyle = function () {
  return (0, _util.getStyleColorVariables)({
    color: _this.getSelectedColor(),
    style: _this.getSelectedStyle()
  });
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('menu-item-card-style')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/menu/items/menu-item-card-style.html
// module id = 694
// module chunks = 0